













































































































import { Component, Prop, PropSync } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { InputCode } from '@/components/molecules/InputCode'
import { OrderStatus } from '@/types'

export interface InputEditBasicItem {
  id: {
    input: string
    errorMessage: string
  }
  managementFlag: {
    input: string
    errorMessage: string
  }
  storeType: {
    input: string
    errorMessage: string
  }
  status: {
    input: string
    errorMessage: string
  }
  collectionType: {
    input: string
    errorMessage: string
  }
  appendixCode: {
    input: string
    errorMessage: string
  }
  cancelReason: {
    input: string
    errorMessage: string
  }
  handlingType: {
    input: string
    errorMessage: string
  }
}

export const defaultInputEditBasicItem = (): InputEditBasicItem => ({
  id: {
    input: '',
    errorMessage: ''
  },
  managementFlag: {
    input: '',
    errorMessage: ''
  },
  storeType: {
    input: '',
    errorMessage: ''
  },
  status: {
    input: '',
    errorMessage: ''
  },
  collectionType: {
    input: '',
    errorMessage: ''
  },
  appendixCode: {
    input: '',
    errorMessage: ''
  },
  cancelReason: {
    input: '',
    errorMessage: ''
  },
  handlingType: {
    input: '',
    errorMessage: ''
  }
})

const STATUS_EXCLUSION_CODES: string[] = [
  OrderStatus.Accept,
  OrderStatus.TempAccept
]

@Component({
  components: {
    InputCode
  }
})
export default class CollectionEditOrderCollectionBasicInfo extends ComponentVue {
  @Prop({
    type: Number,
    required: true
  })
  id!: number

  @PropSync('input', {
    type: Object,
    required: true
  })
  inputItem!: InputEditBasicItem

  get statusExclusionCodes(): string[] {
    return STATUS_EXCLUSION_CODES
  }

  existsErrorMessage(errorMessage: string): boolean {
    return errorMessage !== ''
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }
}
